import { parse } from '@legacy/js/date/date-fns.js';

export default class BatchClubFeeAssignment {
    static ACTION_NAME = 'ClubFeeAssignment';

    constructor() {
        this.action = BatchClubFeeAssignment.ACTION_NAME;
        this.entity = 'ClubMember';
        this.note = '';
        this.start = null;
        this.end = null;
        this.discount = null;
        this.settleWithCredit = false;
        this.quantityFactor = 1;
        this.fixedPriceDiscount = null;
        this.fixedPriceDiscountNetOrGross = 'gross';
        this.clubFeeVat = null;
    }

    serialize() {
        const startDate = parse(this.start, 'dd.MM.yyyy', new Date());
        const endDate = this.end === null ? null : parse(this.end, 'dd.MM.yyyy', new Date());
        const start = { day: startDate.getDate(), month: startDate.getMonth() + 1, year: startDate.getFullYear() };
        const end = endDate === null || this.clubFee?.basePrice.type === 'oneTime' ? null : { day: endDate.getDate(), month: endDate.getMonth() + 1, year: endDate.getFullYear() };
        const percentageDiscount = this.discount?.id === 'individual' ? null : this.discount?.id;
        const fixedPriceDiscount = this.discount?.id !== 'individual'
            ? null
            : {
                    amount: {
                        numerator: Math.round(this.fixedPriceDiscount * 100),
                        denominator: 100,
                    },
                    vat: {
                        numerator: this.clubFeeVat * 100,
                        denominator: 10000,
                    },
                    netOrGross: this.fixedPriceDiscountNetOrGross,
                    currency: this.clubFee ? this.clubFee.basePrice.currency : null,
                };
        return {
            action: this.action,
            entity: this.entity,
            ids: this.ids,
            clubFeeId: this.clubFee?.id,
            settleWithCredit: this.settleWithCredit,
            note: this.note,
            quantityFactor: { numerator: this.quantityFactor, denominator: 1 },
            runTime: { start, end },
            percentageDiscount,
            fixedPriceDiscount,
        };
    }

    isValid() {
        if (!this.clubFee) {
            return false;
        }
        if (!this.start) {
            return false;
        }
        if (!this.ids || this.ids.length === 0) {
            return false;
        }
        return true;
    }
}
